import { SampleProjectCard } from '../case-studies/sample-project-card';

export function CaseStudiesMobile() {
  return (
    <section 
      id="projects-mobile"
      className="w-full px-2.5 mt-20"
    >
      <div className="w-full max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-8">
          <h2 className="font-body text-lg font-light text-foreground mb-4">
            PROJECTS
          </h2>
          <p className="font-heading text-3xl text-foreground">
            Selected Work
          </p>
          <p className="font-body text-sm text-muted-foreground mt-4 leading-relaxed max-w-lg mx-auto">
            A growing collection of practical products, platforms, and automation systems.
          </p>
        </div>
        <SampleProjectCard />
      </div>
    </section>
  );
}
